import { TFetchThreadsRequest } from "../types";

type ThreadParams = {
    userId: string;
    page?: number;
    sortOrder?: 'asc' | 'desc';
    search?: string;
    onlyFavorites?: boolean;
};

export const mapFetchThreadsRequestParams = (params: ThreadParams): TFetchThreadsRequest => {

    const request: TFetchThreadsRequest = {
        userId: params.userId,
        page: params.page || 1,
        limit: 25,
        sortOrder: params.sortOrder || 'desc',
        orderBy: 'last_updated',
        searchValue: params.search || "",
        onlyFavorites: params.onlyFavorites || false,
    }
    return request;
}